import { render, staticRenderFns } from "./ReviewNav.vue?vue&type=template&id=07bf9a84"
import script from "./ReviewNav.vue?vue&type=script&lang=js"
export * from "./ReviewNav.vue?vue&type=script&lang=js"
import style0 from "./ReviewNav.vue?vue&type=style&index=0&id=07bf9a84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports